import { ref as a, reactive as d, onMounted as u, watch as m, onUnmounted as p } from "vue";
function f(o, n, e, i, t, r) {
  const l = document.querySelector(`${o}[${n}="${e}"]`);
  if (l)
    typeof i == "string" ? l.content = i : l.content = i.value;
  else {
    const c = document.createElement(o);
    c.setAttribute(n, e), typeof i == "string" ? c.content = i : (c.content = i.value, t && (c.httpEquiv = t), r && c.setAttribute("charset", r), m(i, () => {
      c.content = i.value;
    })), document.head.appendChild(c);
  }
}
function h(o, n, e, i, t, r) {
  const l = document.querySelector(`${o}[${n}="${e}"]`);
  if (l)
    l.href = i;
  else {
    const c = document.createElement(o);
    c.setAttribute(n, e), c.href = i, r && (c.as = r), t && (c.integrity = t), document.head.appendChild(c);
  }
}
function E(o) {
  o.forEach((n) => {
    if (typeof n == "string") {
      const e = document.createElement("script");
      e.innerHTML = n, document.head.appendChild(e);
    } else if (typeof n == "object") {
      const e = document.createElement("script");
      e.src = n.src, n.defer && (e.defer = !0), document.head.appendChild(e);
    }
  });
}
function s(o, n, e) {
  e.forEach((i) => {
    let t = `${o}[${n}="${i[n]}"]`;
    o === "script" && typeof i == "object" && (t = `script[src="${i.src}"]`);
    const r = document.querySelector(t);
    r && r.remove();
  });
}
function $(o) {
  document.title = o;
}
function v() {
  return document.title;
}
function w(o) {
  o.forEach((n) => {
    f("meta", "name", n.name, n.content, n.httpEquiv, n.charset);
  });
}
function b(o) {
  const n = a(document.title), e = d(o), i = () => {
    e.title && (document.title = e.title), e.meta && e.meta.forEach((t) => {
      f("meta", "name", t.name, t.content);
    }), e.link && e.link.forEach((t) => {
      h("link", "rel", t.rel, t.href, t.integrity, t.as);
    }), e.og && e.og.forEach((t) => {
      f("meta", "property", t.property, t.content);
    }), e.twitter && e.twitter.forEach((t) => {
      f("meta", "name", t.name, t.content);
    }), e.styles && e.styles.forEach((t) => {
      const r = document.createElement("style");
      r.innerHTML = t, document.head.appendChild(r);
    }), e.scripts && E(e.scripts);
  };
  u(i), m(e, i, { deep: !0 }), p(() => {
    document.title = n.value, e.meta && s("meta", "name", e.meta), e.link && s("link", "rel", e.link), e.og && s("meta", "property", e.og), e.twitter && s("meta", "name", e.twitter), e.styles && s("style", "", e.styles), e.scripts && s("script", "src", e.scripts);
  });
}
function g() {
  return {
    install(o) {
    }
  };
}
export {
  g as createVue3Head,
  v as getTitle,
  w as setMeta,
  $ as setTitle,
  b as useHead
};
